<template>
  <div class="page" v-if="page && page.partials && page.partials.length">
    <PartialsLoader :partials="page.partials" />
    <Footer />
  </div>
</template>

<script>
import PartialsLoader from "@components/PartialsLoader";
import Footer from "@components/global/Footer";
import { mapGetters } from "vuex";

export default {
  components: {
    PartialsLoader,
    Footer
  },
  metaInfo() {
    return {
      title: this.getTitle(),
      titleTemplate: '%s | Dinamo Digitale',
      meta: [
        { name: 'og:title', content: this.getTitle() + ' | Dinamo Digitale'},
        { name: 'twitter:title', content: this.getTitle() + ' | Dinamo Digitale'},
        { name: 'description', content: this.getAbstract()},
        { name: 'og:description', content: this.getAbstract()},
        { name: 'twitter:description', content: this.getAbstract()},
        { name: 'keywords', content: this.getDescription()},
        { name: 'og:type', content: 'website'},
        { name: 'og:url', content: window.location.href},
        { name: 'og:image', content: this.getPageImage()},
        { name: 'twitter:image', content: this.getPageImage()},
      ]
    }
  },
  data() {
    return {
      isLogged: false,
      resourceUrl: process.env.VUE_APP_RESOURCES,
      defaultTitle: 'Dinamo',
      defaultDescription: 'Integriamo marketing e tecnologia',
      defaultKeywords: 'consulenza design marketing sviluppo integrazione'
    };
  },
  mounted() {
    this.getPage(this.$route.params.page);
  },
  methods: {
    getPage(slug) {
      this.$store.dispatch("getPage", slug);
    },
    getTitle() {
      if (this.page && this.page.title) {
        return this.page.title
      }
      return this.defaultTitle
    },
    getAbstract() {
      if (this.page && this.page.abstract) {
        return this.page.abstract
      }
      return this.defaultDescription
    },
    getDescription() {
      if (this.page && this.page.description) {
        return this.page.description
      }
      return this.defaultKeywords
    },
    getPageImage() {
      if (this.page && this.page.mainImage && this.page.mainImage.file && this.page.mainImage.file.path) {
        return this.resourceUrl + this.page.mainImage.file.path
      } else if (this.page && this.page.mobileImage && this.page.mobileImage.file && this.page.mobileImage.file.path) {
        return this.resourceUrl + this.page.mobileImage.file.path
      }
      return undefined
    }
  },
  computed: {
    ...mapGetters({
      page: "getPage"
    })
  }
};
</script>

<style lang="scss" scoped>
@import "@assets/scss/_importer.scss";
.page {
  padding: 64px;
  @include breakpoint(medium down) {
    padding: 0 0 64px;
  }
}
</style>
